import React from "react";
import CircleInfo from "@/assets/circle-info.svg";

const DateOfBirthAlert: React.FC = () => {
  return (
    <div
      className="mt-[16px] mb-[32px] flex space-x-[12px] p-[12px] rounded-[12px]"
      style={{ boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.10)" }}
    >
      <img src={CircleInfo} className="w-[24px] h-[24px]" alt="Information" />
      <p className="text-[#021212] leading-[127%] text-[14px] font-outfit">
        We noticed that your employer did not provide us with your date of birth
        information, in order for us to finish setting up your account, please
        add your date of birth information in the next step.
      </p>
    </div>
  );
};

export default DateOfBirthAlert;
